import { Modal, ModalProps } from "react-bootstrap";

interface IdleScreenTimeModalProps extends ModalProps {
  onHide: () => void;
  onContinue: () => void;
  onQuit: () => void;
}

const IdleScreenTimeModal = ({
  onHide,
  onContinue,
  onQuit,
  ...props
}: IdleScreenTimeModalProps) => {
  return (
    <Modal
      {...props}
      onHide={onHide}
      backdrop="static"
      backdropClassName="idleModalBackdrop"
      className="idleModal"
      keyboard={false}
      centered
      scrollable={false}
      enforceFocus={false}
    >
      <Modal.Body>
        <div className="otpModalBody mt-2">
          <div className="header">
            Are you still there?
          </div>
          <div className="description">
            Your session is about to expire due to inactivity. <br/> Continue now to keep creating.
          </div>
          <div className="d-flex gap-3 mx-5">
            <button
              type="button"
              className="btnPrimary w-100"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onContinue();
              }}
            >
              Continue
            </button>
            <button
              type="button"
              className="btnOutline w-100"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onQuit();
              }}
            >
              Quit
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default IdleScreenTimeModal;
